export enum ModuleEnum {
	book = 'book',
	dna = 'dna',
	morfologic = 'morfologic',
	performance = 'performance-control',
	genetic = 'genetic',
	admin = 'admin',
	reproduction = 'reproduction',
	milking = 'milking',
}
